import React, { useEffect, useState } from 'react';

export function usePromiseFunc<T>(func: () => Promise<T>): () => void {
  const [ready, setReady] = useState(true);
  const [promise, setPromise] = useState<Promise<T> | null>(null);
  if (promise) {
    // eslint-disable-next-line @typescript-eslint/no-throw-literal
    throw promise;
  }

  return () => {
    if (!ready) {
      return;
    }
    const newPromise = func().finally(() => {
      setPromise(null);
      setReady(true);
    });
    setPromise(newPromise);
    setReady(false);
  };
}

export function usePromiseFuncWithData<T, D>(func: (data: D) => Promise<T>): (data: D) => void {
  const [ready, setReady] = useState(true);
  const [promise, setPromise] = useState<Promise<T> | null>(null);
  if (promise) {
    // eslint-disable-next-line @typescript-eslint/no-throw-literal
    throw promise;
  }

  return data => {
    if (!ready) {
      return;
    }
    const newPromise = func(data).finally(() => {
      setPromise(null);
      setReady(true);
    });
    setPromise(newPromise);
    setReady(false);
  };
}

export function useAsyncEffect(func: () => Promise<void>, status: React.DependencyList): void {
  const [promise, setPromise] = useState<Promise<void> | null>(null);
  useEffect(() => {
    // console.info(`start ${id}`);
    const newPromise = func().finally(() => {
      setPromise(null);
    });
    setPromise(newPromise);
  }, status);
  if (promise) {
    // eslint-disable-next-line @typescript-eslint/no-throw-literal
    throw promise;
  }
}
